import React from 'react';

const ModalWrapper = props => {
  const height = window.outerHeight - 80;
  return (
    <div className="modal-bg position-fixed w-100">
      <button className="close position-absolute bg-white font-20" onClick={props.actionsModal('close')}>X</button>
      <div className="modal-box bg-white p-4" style={{height: 'auto', 'maxHeight': height + 'px'}}>
        {props.children}
      </div>
    </div>
  );
};

export default ModalWrapper;



// WEBPACK FOOTER //
// ./src/components/ModalWrapper.js